<template>
  <div>
    <custom :total="isTotals" />
    <br />
    <div class="card-list">
      <div class="card-item" v-for="(i, index) in jobs" :key="index">
        <div class="card" @click="openJobDetail(i._id)">
          <div class="card-content">
            <img :src="$urlImageShow + i.file" />
          </div>
          <div class="card-footer">
            <h3>{{ i.employerId.companyName }}</h3>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide">
      <pinJobDeatil v-if="viewJobDetail" @cancel="viewJobDetail = false" />
    </transition>
  </div>
</template>

<script>
import { getPinJobAPIS } from "@/apis/Pin-Job";
import pinJobDeatil from "./pinjob-detail.vue";
import custom from "@/components/Pagination/customPagination";
export default {
  components: { pinJobDeatil, custom },
  data: () => ({
    viewJobDetail: false,
    page: 1,
    jobs: [],
    isTotals: "",
  }),
  methods: {
    openJobDetail(id) {
      this.$router
        .push({
          name: "pin-job",
          query: {
            type: this.$route.query.type,
            q: this.$route.query.q,
            p: this.$route.query.p,
            s: this.$route.query.s,
            id: id,
          },
        })
        .catch(() => { });
      this.viewJobDetail = !this.viewJobDetail;
    },
    async fetchPinJob() {
      const form = {
        type: this.$route.query.type,
        page: parseInt(this.$route.query.q) || 1,
        perPage: parseInt(this.$route.query.p) || 10,
        search: this.$route.query.s || "",
      };
      const res = await getPinJobAPIS(form);
      this.jobs = res.infoList;
      this.isTotals = res.totals;
    },
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val) {
          this.fetchPinJob();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.fetchPinJob();
  },
};
</script>

<style lang="scss" scoped>
.card-list {
  column-count: 4;
  gap: 20px;

  .card-item {
    margin: 0;
    display: grid;
    grid-template-rows: 1fr auto;
    margin-bottom: 20px;
    break-inside: avoid;
  }
}

.card {
  box-shadow: none !important;
  border: 1px solid var(--border-color);

  .card-content {
    padding: 15px;
    padding: 0 !important;

    img {
      display: block;
    }
  }

  .card-footer {
    padding: 15px;

    h3 {
      line-height: 1.5;
      font-size: var(--sm-font);
      font-weight: 700;
    }
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-enter {
  opacity: 0;
  transform: translateX(20px);
}

.slide-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
